import React from 'react';
import ImageGalleryilmfoundation from '../components/ImageGalleryilmfoundation';
import DonationDetailsIlmsection from "./DonationDetailsIlmsection";

const IRCDAWAH = () => {
    return (
        <>
            <div className="about-us-container">
                <section className="activities-details">
                    <button
                        onClick={() => window.history.back()}
                        style={{
                            marginBottom: '10px',
                            padding: '8px 10px',
                            backgroundColor: '#255fe8',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        ← Back to All Activities
                    </button>
                    <div className="activity-intro">
                        <h2>OUR ACTIVITIES</h2>
                        <p>
                            All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities
                        </p>
                    </div>

                    <ImageGalleryilmfoundation />

                    {/* IRC 10 Days WEEKLY */}
                    <div className="activity-card">
                        <div className="activity-header">
                            <h3>ILM FOUNDATION EDUCATION & WELFARE WAKF</h3>
                        </div>
                        <div className="activity-content">
                            <p>
                                ILM Foundation Education & Welfare Wakf is an Religious Trust, the foundation is dedicated to uplifting society through initiatives in Religion, education, healthcare, and social welfare. Join us in embracing the true spirit of Islamic teachings, any donation towards masjid should be deposited in ILM Foundation Education & Welfare Wakf.
                            </p>
                        </div>
                        <DonationDetailsIlmsection
                          
                        />
                    </div>
                </section>
            </div>
        </>
    );
};

export default IRCDAWAH;
